<template>
  <div class="page">
    <div class="timeline-container">
      <div
        class="timeline-scroll"
        ref="scrollContainer"
        @mousedown="onDragStart"
        @touchstart="onDragStart"
      >
        <div class="timeline-track">
          <!-- 发展节点 -->
          <div
            v-for="(item, index) in nodeDatas"
            :key="`node-${index}`"
            :data-index="index"
            class="timeline-node"
            @click="handleNodeClick(index)"
          >
            <!-- 上部分 -->
            <div class="node-top">
              <!-- 单数节点显示内容，双数节点显示时间 -->
              <template v-if="index % 2 === 0">
                <div class="content-desc">
                  <p
                    class="describe-text"
                    :class="{ 'describe-text-active': currentNode === index }"
                    v-for="(line, i) in item.desc"
                    :key="i"
                  >
                    <img loading="lazy" src="@/assets/AboutUS/item2.png" alt />
                    {{ line }}
                  </p>
                </div>
              </template>
              <template v-else>
                <div
                  class="time-text"
                  :class="{ 'time-text-active': currentNode === index }"
                >
                  {{ item.year }}
                </div>
                <div
                  class="title"
                  :class="{ 'title-active': currentNode === index }"
                >
                  {{ item.title }}
                </div>
              </template>
            </div>
            <!-- 圆点 -->
            <div
              class="node-dot"
              :class="{ 'node-dot-active': currentNode === index }"
            ></div>
            <!-- 下部分 -->
            <div class="node-bottom">
              <!-- 单数节点显示时间，双数节点显示内容 -->
              <template v-if="index % 2 === 0">
                <div
                  class="title"
                  :class="{ 'title-active': currentNode === index }"
                >
                  {{ item.title }}
                </div>
                <div
                  class="time-text"
                  :class="{ 'time-text-active': currentNode === index }"
                >
                  {{ item.year }}
                </div>
              </template>
              <template v-else>
                <div class="content-desc">
                  <p
                    class="describe-text"
                    :class="{ 'describe-text-active': currentNode === index }"
                    v-for="(line, i) in item.desc"
                    :key="i"
                  >
                    <img loading="lazy" src="@/assets/AboutUS/item2.png" alt />
                    {{ line }}
                  </p>
                </div>
              </template>
            </div>
          </div>
          <!-- 连接线 -->
          <div class="timeline-line"></div>
        </div>
      </div>
      <!-- 滑动提示 -->
      <div class="scroll-tip">
        <span class="tip-text">往左滑动 </span>
        <span class="tip-arrow">→</span>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  name: "DevelopLine",
  props: {
    nodeDatas: {
      type: Array,
      required: true,
      default: () => [],
    },
    activetNode: {
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      currentNode: this.activetNode,
      isDragging: false,
      startX: 0,
      startScrollLeft: 0
    }
  },
  methods: {
    handleNodeClick(index) {
      this.currentNode = index;
      const container = this.$refs.scrollContainer;
      if (!container) return;

      // 获取所有节点
      const nodes = container.querySelectorAll('.timeline-node');
      const node = nodes[index];
      if (!node) return;

      // 计算滚动位置
      const containerRect = container.getBoundingClientRect();
      const nodeRect = node.getBoundingClientRect();

      // 目标滚动位置 = 当前滚动位置 + 节点位置 - 容器中心位置
      const targetScrollLeft = container.scrollLeft + (nodeRect.left - containerRect.left) - (containerRect.width / 2) + (nodeRect.width / 2);

      container.scrollTo({
        left: targetScrollLeft,
        behavior: 'smooth'
      });
    },
    onDragStart(e) {
      // 使用Pointer Events统一处理
      this.isDragging = true;
      this.startX = e.clientX || e.pageX;
      const container = this.$refs.scrollContainer;
      if (container) {
        this.startScrollLeft = container.scrollLeft;
      }
      // 只绑定pointer事件
      document.addEventListener('pointermove', this.onDragMove, { passive: false });
      document.addEventListener('pointerup', this.onDragEnd, { passive: false });
      document.addEventListener('pointercancel', this.onDragEnd, { passive: false });
    },
    onDragMove(e) {
      if (!this.isDragging) return;

      const container = this.$refs.scrollContainer;
      if (!container) return;

      e.preventDefault();
      const currentX = e.clientX || e.pageX;
      // 添加边界限制
      const maxScrollLeft = container.scrollWidth - container.clientWidth;
      const targetScrollLeft = this.startScrollLeft - (currentX - this.startX);
      container.scrollLeft = Math.max(0, Math.min(targetScrollLeft, maxScrollLeft));
    },
    onDragEnd() {
      this.isDragging = false;
      // 解绑pointer事件
      document.removeEventListener('pointermove', this.onDragMove);
      document.removeEventListener('pointerup', this.onDragEnd);
      document.removeEventListener('pointercancel', this.onDragEnd);
    }
  },
  mounted() {
    // 移除原来的mouse/touch事件绑定
    // 使用pointerdown替代mousedown和touchstart
    const container = this.$refs.scrollContainer;
    if (container) {
      container.addEventListener('pointerdown', this.onDragStart);
    }
  },
  beforeDestroy() {
    // 清理事件监听
    const container = this.$refs.scrollContainer;
    if (container) {
      container.removeEventListener('pointerdown', this.onDragStart);
    }
    document.removeEventListener('pointermove', this.onDragMove);
    document.removeEventListener('pointerup', this.onDragEnd);
    document.removeEventListener('pointercancel', this.onDragEnd);
  },
  watch: {
    activetNode(newVal) {
      this.currentNode = newVal;
    }
  }
}
</script>

<style lang="scss" scoped>
// 脉冲动画
@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(42, 123, 220, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(42, 123, 220, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(42, 123, 220, 0);
  }
}

@keyframes arrowShake {
  0%,
  100% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-4px);
  }
  75% {
    transform: translateX(4px);
  }
}
.page {
  display: flex;
  justify-content: center;
  overflow: hidden;
  user-select: none;
  .timeline-container {
    width: 1200px;
    overflow: hidden;
    height: 540px;
    padding: 2rem;
    background-color: #f8f9fb;
    position: relative;
    .timeline-scroll {
      width: 95%;
      height: 100%;
      overflow-x: auto;
      overflow-y: hidden;
      scrollbar-width: none; // 隐藏Firefox滚动条
      -ms-overflow-style: none; // 隐藏IE滚动条
      //  隐藏Chrome滚动条
      &::-webkit-scrollbar {
        display: none;
      }
      .timeline-track {
        height: 100%;
        display: flex;
        align-items: center;
        position: relative;
        padding: 20px 0;
        width: fit-content; // 让轨道宽度适应内容
        .timeline-node {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 300px;
          height: 500px;
          position: relative;
          z-index: 2;
          .title {
            font-size: 2.2rem;
            cursor: pointer;
            font-weight: bold;
            padding: 1rem 0;
          }
          .time-text {
            font-size: 1.6rem;
            cursor: pointer;
          }
          .content-desc {
            cursor: pointer;
            .describe-text {
              text-align: left;
              line-height: 1.3;
            }
            img {
              width: 2rem;
              height: 2rem;
              margin: 0;
              padding: 0;
            }
          }
          .node-top {
            height: 48%;
            width: 100%;
            display: flex;
            flex-direction: column-reverse;
          }
          .node-dot {
            width: 20px;
            height: 4%;
            border-radius: 50%;
            border: 1px solid #2a7bdc;
            cursor: pointer;
            background-color: #f8f9fb;
          }
          .node-dot-active {
            background-color: #2a7bdc;
            // 选中时圆点放大并添加脉冲效果
            transform: scale(1.1);
            box-shadow: 0 0 0 rgba(42, 123, 220, 0.8);
            animation: pulse 1.5s infinite;
          }
          .time-text-active,
          .title-active,
          .describe-text-active {
            color: #2a7bdc;
          }
          .title-active {
            transform: scale(1.1);
          }
          .node-bottom {
            height: 48%;
            width: 100%;
          }
        }

        .timeline-line {
          position: absolute;
          transform: translateY(-50%); // 精确居中
          left: 0;
          width: calc(500px * 4);
          margin-left: 150px;
          height: 2px;
          background-color: #2a7bdc;
          z-index: 1;
        }
      }
    }
    .scroll-tip {
      // 固定在时间轴右侧中间位置
      position: absolute;
      right: 15px;
      top: 50%;
      width: 4%;
      height: auto;
      transform: translateY(-50%);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 8px;
      padding: 8px 12px;
      background-color: rgba(255, 255, 255, 0.9);
      border-radius: 20px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      pointer-events: none; // 不影响用户拖拽时间轴
      .tip-text {
        font-size: 1.6rem;
        color: #666;
      }
      .tip-arrow {
        font-size: 1.8rem;
        color: #2a7bdc;
        animation: arrowShake 1.2s ease-in-out infinite;
      }
    }
  }
}
// 响应式设计
@media screen and (max-width: 768px) {
  .page {
    .timeline-container {
      width: 100%;
      height: 440px;
      padding: 1rem 0.5rem;
      .timeline-scroll {
        width: 93% !important;
        height: 100%;
        .timeline-track {
          padding: 10px 0;
          .timeline-node {
            width: 220px;
            height: 350px;
            .title {
              font-size: 1.5rem;
            }
            .time-text {
              font-size: 1.2rem;
            }
            .content-desc {
              font-size: 0.85rem;
              img {
                width: 1.2rem;
                height: 1.2rem;
              }
              .describe-text {
                margin: 2px !important;
              }
            }
            .node-dot {
              width: 16px;
              height: 16px;
            }
          }
          .timeline-line {
            width: calc(220px * 7);
            margin-left: 110px;
          }
        }
      }
      .scroll-tip {
        right: 8px;
        padding: 6px 10px;
        gap: 6px;
        .tip-text {
          font-size: 1.2rem;
        }
        .tip-arrow {
          font-size: 1.4rem;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DevelopLine.vue